<template>
  <Box class="review-io" is-flex flex-direction="column" align-items="center" gap="5">
    <Box is-flex flex-direction="row" align-items="center" gap="2">
      <StarIcon class="review-io__star" />
      <StarIcon class="review-io__star" />
      <StarIcon class="review-io__star" />
      <StarIcon class="review-io__star" />
      <StarIcon class="review-io__star" />
    </Box>
    <Box is-flex flex-direction="row" align-items="center" gap="3">
      <Heading size="h4" align="center">4.95 {{ $t('single_words.stars').toLocaleLowerCase() }}</Heading>
      <CustomText align="center"><strong>3,100+</strong> {{ $t('single_words.reviews').toLocaleLowerCase() }}</CustomText>
    </Box>
    <Box>
      <CustomText size="large" align="center" v-html="$t('pages.ssr_landing.rating.badge_io_description')" />
    </Box>
  </Box>
</template>

<script>
import Heading from '@/components/common/Heading/Heading'
import CustomText from '@/components/common/CustomText/CustomText'
import Box from '@/components/common/Box/Box'
import StarIcon from '@/components/icons/Star'

export default {
  components: {
    Heading,
    Box,
    CustomText,
    StarIcon
  }
}
</script>

<style lang="scss" scoped>
.review-io {
  width: 100%;
  padding: $gap * 1.5 $gap;
  border-radius: 8px;
  background: #372059;
  border: 1px solid #4a3669;

  &__star {
    height: 28px;
    width: 28px;
  }
}
</style>
